export default {
    routes: [
        {
            path: '/',
            name: 'home',
            meta: {
                requiresAuth: true
            },
            component: () => import('@/views/index/index.vue')
        },

        {
            path: '/internationalLogin',
            name: 'internationalLogin',
            meta: {
                requiresAuth: true
            },
            component: () => import('./views/index/international.vue')
        },

        {
            path: '/scan',
            name: 'scan',
            component: () => import('@/views/scan/index.vue')
        },
        {
            path: '/401',
            name: '401',
            component: () => import('@/views/errors/401.vue')
        },
        {
            path: '/403',
            name: '403',
            component: () => import('@/views/errors/403.vue')
        },
        {
            path: '/404',
            name: '404',
            component: () => import('@/views/errors/404.vue')
        },
        {
            // 兼容旧版本
            path: '/login',
            redirect: '/'
        },
        {
            // 兼容旧版本
            path: '/error/noPermission',
            redirect: '/401'
        },
        {
            // 兼容旧版本
            path: '/noAuth',
            redirect: '/403'
        },
        {
            path: '/*',
            redirect: '/404'
        }
    ]
};
